import { atom } from 'recoil';

/** 是否显示AI客服 */
export const showAIState = atom({ key: 'showAIState', default: false });
